import { apiClient } from "@/api/api-client.ts";
import type { CaseFilingAttachmentFormSchema, CaseFilingForm, CaseFilingResponse } from "../../types/case-filing";

const caseFilingService = {
	saveCaseInformation: async (data: CaseFilingForm): Promise<CaseFilingResponse> => {
		const response = await apiClient.post<{ data: CaseFilingResponse }>("/case-filing/save-information", data);
		return response.data.data;
	},
	saveCaseInformationAttachment: async (data: CaseFilingAttachmentFormSchema): Promise<CaseFilingAttachmentFormSchema> => {
		const response = await apiClient.post<{ data: CaseFilingAttachmentFormSchema }>("/case-filing/save-case-attachment", data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data.data;
	},
	saveCaseInformationEvidence: async (data: CaseFilingAttachmentFormSchema): Promise<CaseFilingAttachmentFormSchema> => {
		const response = await apiClient.post<{ data: CaseFilingAttachmentFormSchema }>("/case-filing/save-case-evidence", data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data.data;
	},
	getCaseFilingById: async (caseId: string): Promise<CaseFilingResponse> => {
		const response = await apiClient.get<{ data: CaseFilingResponse }>(`/case-filing/${caseId}`);
		return response.data.data;
	},
};

export default caseFilingService;
